import React from 'react';
import { connect } from 'react-redux';

import { signInRequest, signInRequestWithPassword, signInRequestWithMicrosoft } from '../../../actionCreators/auth';
import {
  getSecurityQuestionsRequest,
  validateSecurityRequest,
} from '../../../actionCreators/account';
import SignInComponent from '../../../components/Auth/SignIn';
import { addAlertToAlertsList } from '../../../actionCreators/globalAlerts';
import {getCustomAppRequest} from "../../../actionCreators/customApp";


const SignIn = props => <SignInComponent {...props} />;

const mapStateToProps = state => ({
  currentUser: state.currentUser,
  account: state.account,
  customAppId: state.customApp.id,
  azureClientId: state.customApp.azure_client_id,
  azureTenantId: state.customApp.azure_tenant_id,
  organisationId: state.customApp.organisation_id
});

const mapDispatchToProps = dispatch => ({
  reloadCustomApp: payload => dispatch(getCustomAppRequest(payload)),
  signIn: payload => dispatch(signInRequest(payload)),
  signInWithPassword: payload => dispatch(signInRequestWithPassword(payload)),
  addAlertToAlerts: payload => dispatch(addAlertToAlertsList(payload)),
  getSecurityQuestions: () => dispatch(getSecurityQuestionsRequest()),
  validateSecurity: payload => dispatch(validateSecurityRequest(payload)),
  signInWithMicrosoft: payload => dispatch(signInRequestWithMicrosoft(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
